<div class="personal-details-page">
  <div class="column column1">
    <div>
      <app-toggle-input
        [groupBy2InLine]="true"
        placeholder="PersonalDetailsInfo.PremiumDeductible"
        [form]="form"
        [optionsList]="yesNoList"
        [control]="form.get('deductPremiumFromTaxes')"
        appConfigSettingsParagraph
        required
        isRequiredMessageKey="Calculation.RequiredField"
        additionalInfoInsurer="Common.PremiumDeductibleInfo"
      ></app-toggle-input>
    </div>
    <div>
      <app-text-input
        appConfigSettingsInput
        placeholder="PersonalDetailsInfo.AnnualIncome"
        [control]="form.get('averageYearIncome')"
        [form]="form"
        [thousandSeparator]="thousandSeparator"
        showPlaceholder="false"
        inputMask="separator.0"
        prefix="€ "
        additionalInfoInsurer="Common.AnnualIncomeInfo"
      ></app-text-input>
    </div>
    <div>
      <app-text-input
        appConfigSettingsInput
        placeholder="PersonalDetailsInfo.MonthlyExpenses"
        [control]="form.get('monthlyExpenses')"
        [form]="form"
        showPlaceholder="false"
        inputMask="separator.0"
        [thousandSeparator]="thousandSeparator"
        prefix="€ "
        (toggleCalculator)="toggleCalculator()"
        isCalculatorShown="true"
      ></app-text-input>
    </div>
    <div>
      <app-toggle-input
        [groupBy2InLine]="true"
        placeholder="PersonalDetailsInfo.AOVInsurance"
        [form]="form"
        [optionsList]="yesNoList"
        [control]="form.get('insuranceSomewhereElse')"
        appConfigSettingsParagraph
        required
        isRequiredMessageKey="Calculation.RequiredField"
      ></app-toggle-input>
    </div>
    <div *ngIf="IsAOVPresent">
      <div>
        <app-text-input
          appConfigSettingsInput
          placeholder="PersonalDetailsInfo.NameInsurer"
          [control]="form.get('companyName')"
          [form]="form"
          showPlaceholder="false"
        ></app-text-input>
      </div>
      <div>
        <app-text-input
          appConfigSettingsInput
          placeholder="PersonalDetailsInfo.InsuredAnnualAmount"
          [control]="form.get('sumAssuredAOV')"
          [form]="form"
          showPlaceholder="false"
          inputMask="separator.0"
          [thousandSeparator]="thousandSeparator"
          prefix="€ "
        ></app-text-input>
      </div>
      <div>
        <app-toggle-input
          [groupBy2InLine]="true"
          placeholder="PersonalDetailsInfo.CancelAOV"
          [form]="form"
          [optionsList]="yesNoList"
          [control]="form.get('insurerWillCancelInsurance')"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
        ></app-toggle-input>
      </div>
      <div *ngIf="IsCancelAOV">
        <app-date-input
          appConfigSettingsInput
          class="full-width"
          placeholder="PersonalDetailsInfo.DateOfCancelAOV"
          [control]="form.get('cancellationDate')"
          [form]="form"
          datePlaceholder="CalculationInsurer.DateOfBirthPlaceholder"
          [dateMask]="dateMaskFormat"
        ></app-date-input>
      </div>
    </div>
  </div>
</div>

